import React, { useEffect, useState } from "react";
import "../styles/ProductManagement.css";
import ProductManagmentIcon from "../icons/BusinessHub/ProductManagmentIcon";
import TotalProdIcon from "../icons/BusinessHub/TotalProdIcon";
import SandClock from "../icons/BusinessHub/sandClock";
import QrIcon from "../icons/BusinessHub/QrIcon";
import ExpiredIcon from "../icons/BusinessHub/ExpiredIcon";
import NoteWarning from "../icons/BusinessHub/NoteWarning";
import FrontArrow from "../icons/BusinessHub/FrontArrow";
import ProductSubmission from "../icons/BusinessHub/ProductSubmission";
import ProductCatalog from "../icons/BusinessHub/ProductCatalog";
import ShareIcon from "../icons/BusinessHub/ShareIcon";
import SyncIcon from "../icons/BusinessHub/SyncIcon";
import RecentActivity from "../icons/BusinessHub/RecentActivity";
import { useNavigate } from "react-router-dom";
import companyController from "../controllers/companyController";
import { userService } from "../services/userService";

function ProductManagement() {
  const navigate = useNavigate();
  const [data, setdata] = useState("");

  useEffect(() => {
    const getQuickActions = async () => {
      try {
        const QuickActions = await companyController.getQuickActions({
          Authorization: userService.getUser(),
          companyId: userService.getCompID(),
        });
        setdata(QuickActions.data);
      } catch (error) {
        console.error("error", error);
      }
    };

    getQuickActions();
  }, []);
  return (
    <div className="product-management-main-ccontainer">
      <div className="product-management-main-ccontainer-header">
        <div className="product-management-main-ccontainer-header-icon">
          <div className="product-management-header-icon">
            <ProductManagmentIcon fill="#ffffff" size="28px" />
          </div>
        </div>
        <div className="product-management-main-ccontainer-header-text">
          <div className="product-management-header-title-text">
            Product Management
          </div>
          <div className="product-management-header-disc-text">
            Manage QR codes, product submissions, product catalog, <br />
            and ERP synchronization.
          </div>
        </div>
      </div>
      {/*****************bodyF*************** */}
      <div className="product-management-main-ccontainer-firstbody">
        {/*****************bodyFTotal products*************** */}
        <div className="product-management-details-containers">
          <div className="product-management-details">
            <div className="product-management-details-text">
              <div className="product-management-details-text-head">
                Total Products
              </div>
              <div className="product-management-details-number">
                {data?.totalValidatedProducts}
              </div>
              <div className="product-management-details-text-head">
                Validated products
              </div>
            </div>
            <div className="product-management-details-icon">
              <div className="product-management-details-icon-container">
                <TotalProdIcon />
              </div>
            </div>
          </div>
        </div>
        {/*****************bodyFPending*************** */}
        <div className="product-management-details-containers">
          <div className="product-management-details">
            <div className="product-management-details-text">
              <div className="product-management-details-text-head">
                Pending Review
              </div>
              <div className="product-management-details-number">
                {data?.pendingReview}
              </div>
              <div className="product-management-details-text-head">
                Awaiting admin validation
              </div>
            </div>
            <div className="product-management-details-icon">
              <div className="product-management-details-icon-container">
                <SandClock />
              </div>
            </div>
          </div>
        </div>
        {/*****************bodyFEmptyQr*************** */}
        <div className="product-management-details-containers">
          <div className="product-management-details">
            <div className="product-management-details-text">
              <div className="product-management-details-text-head">
                Empty QRs
              </div>
              <div className="product-management-details-number">
                {data?.emptyQrs}
              </div>
              <div className="product-management-details-text-head">
                Available for scanning
              </div>
            </div>
            <div className="product-management-details-icon">
              <div className="product-management-details-icon-container">
                <QrIcon />
              </div>
            </div>
          </div>
        </div>
        {/*****************bodyExpQr*************** */}
        <div className="product-management-details-containers">
          <div className="product-management-details">
            <div className="product-management-details-text">
              <div className="product-management-details-text-head">
                Expired QRs
              </div>
              <div className="product-management-details-number">
                {data?.expiredQrs}
              </div>
              <div className="product-management-details-text-head">
                Auto-expired placeholders
              </div>
            </div>
            <div className="product-management-details-icon">
              <div className="product-management-details-icon-container">
                <ExpiredIcon />
              </div>
            </div>
          </div>
        </div>
        {/*****************bodyERPSyncError*************** */}
        <div className="product-management-details-containers">
          <div className="product-management-details">
            <div className="product-management-details-text">
              <div className="product-management-details-text-head">
                ERP Sync Errors
              </div>
              <div className="product-management-details-number">
                {data?.erpSyncErrors}
              </div>
              <div className="product-management-details-text-head">
                Failed Odoo syncs
              </div>
            </div>
            <div className="product-management-details-icon">
              <div className="product-management-details-icon-container">
                <NoteWarning />
              </div>
            </div>
          </div>
        </div>
      </div>
      {/*****************bodyS*************** */}
      <div className="product-management-main-ccontainer-secondbody">
        <div className="product-management-main-ccontainer-secondbody-text">
          Quick Actions
        </div>
        <div className="product-management-ccontainer-secondbody">
          {/*****************bodySQRcode*************** */}
          <div className="product-management-secondbody-content-constainer">
            <div className="product-management-secondbody-content">
              <div className="product-management-details-icon">
                <div className="product-management-details-icon-container">
                  <QrIcon fill="#424242" />
                </div>
              </div>
              <div className="product-management-secondbody-text">
                <div className="product-management-secondbody-text-title">
                  QR Code Management
                </div>
                <div className="product-management-details-text-head">
                  Generate, export, print, and track QR codes.
                </div>
              </div>
              <div
                className="product-management-secondbody-actionb"
                onClick={() => navigate("/Qr-code-management")}
              >
                Open QR Codes <FrontArrow />
              </div>
            </div>
          </div>
          {/*****************bodySProductSubmtion*************** */}
          <div className="product-management-secondbody-content-constainer">
            <div className="product-management-secondbody-content">
              <div className="product-management-details-icon">
                <div className="product-management-details-icon-container">
                  <ProductSubmission />
                </div>
              </div>
              <div className="product-management-secondbody-text">
                <div className="product-management-secondbody-text-title">
                  Product Submissions
                </div>
                <div className="product-management-details-text-head">
                  Review, approve, or reject submitted products.
                </div>
              </div>
              <div
                className="product-management-secondbody-actionb"
                onClick={() => navigate("/product-submissions")}
              >
                Review Submissions <FrontArrow />
              </div>
            </div>
          </div>
          {/*****************bodySProductCata*************** */}
          <div className="product-management-secondbody-content-constainer">
            <div className="product-management-secondbody-content">
              <div className="product-management-details-icon">
                <div className="product-management-details-icon-container">
                  <ProductCatalog />
                </div>
              </div>
              <div className="product-management-secondbody-text">
                <div className="product-management-secondbody-text-title">
                  Products Catalog
                </div>
                <div className="product-management-details-text-head">
                  Browse validated products and variants.
                </div>
              </div>
              <div
                className="product-management-secondbody-actionb"
                onClick={() => {
                  navigate("/product-catalog");
                }}
              >
                View Products <FrontArrow />
              </div>
            </div>
          </div>
          {/*****************bodySVariant*************** */}
          {/* <div className="product-management-secondbody-content-constainer">
            <div className="product-management-secondbody-content">
              <div className="product-management-details-icon">
                <div className="product-management-details-icon-container">
                  <ShareIcon />
                </div>
              </div>
              <div className="product-management-secondbody-text">
                <div className="product-management-secondbody-text-title">
                  Variants & Attributes
                </div>
                <div className="product-management-details-text-head">
                  Manage product attributes, variants, and SKU structure.
                </div>
              </div>
              <div className="product-management-secondbody-actionb">
                Manage Variants <FrontArrow />
              </div>
            </div>
          </div> */}
          {/*****************bodySVariant*************** */}
          {/* <div className="product-management-secondbody-content-constainer">
            <div className="product-management-secondbody-content">
              <div className="product-management-details-icon">
                <div className="product-management-details-icon-container">
                  <SyncIcon />
                </div>
              </div>
              <div className="product-management-secondbody-text">
                <div className="product-management-secondbody-text-title">
                  ERP Synchronization
                </div>
                <div className="product-management-details-text-head">
                  Monitor Odoo sync status and failures.
                </div>
              </div>
              <div className="product-management-secondbody-actionb">
                View Integrations <FrontArrow />
              </div>
            </div>
          </div> */}
        </div>
      </div>
      {/*****************footer*************** */}
      <div className="product-management-main-ccontainer-footer">
        <div className="product-management-footer-activities">
          <div className="product-management-cont-footer-activities">
            <div className="product-management-footer-activities-title">
              Recent Activity
            </div>
            <div className="product-management-footer-activities-content">
              {data?.recentActivity?.[0]?.message === "No recent activity" ? (
                <div className="product-management-footer-activities-rows">
                  <div className="product-management-footer-activities-rows-text">
                    <div className="product-management-footer-activities-rows-text-empty">
                      All operations normal
                    </div>
                  </div>
                </div>
              ) : (
                data?.recentActivity?.map((activity, index) => (
                  <div
                    key={index}
                    className="product-management-footer-activities-rows"
                  >
                    <div className="product-management-footer-activities-rows-icon">
                      <RecentActivity fill="" />
                    </div>

                    <div className="product-management-footer-activities-rows-text">
                      <div className="product-management-footer-activities-rows-text-title">
                        {activity.message}
                      </div>

                      <div className="product-management-footer-activities-rows-text-disc">
                        {activity.timeAgo}
                      </div>
                    </div>
                  </div>
                ))
              )}
            </div>
          </div>
        </div>
        <div className="product-management-footer-attention-req">
          <div className="product-management-attention-req-cont">
            <div className="product-management-attention-req-title">
              Attention Required
            </div>
            <div className="product-management-attention-req-body">
              {data?.attentionRequired?.[0] === "All operations normal" ? (
                <div className="product-management-attention-req-rows">
                  <div className="product-management-attention-req-row-cont">
                    <div className="product-management-attention-req-discrip">
                      All operations normal
                    </div>
                  </div>
                </div>
              ) : (
                data?.attentionRequired?.map((item, index) => (
                  <div
                    key={index}
                    className="product-management-attention-req-rows"
                  >
                    <div className="product-management-attention-req-row-cont">
                      <div className="product-management-attention-req-disc">
                        {item}
                      </div>
                    </div>
                  </div>
                ))
              )}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default ProductManagement;
